<ng-container>
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
    <div class="flex flex-col text-darkGray">
      <span class="text-[20px] font-semibold">Your QRIS Lists</span>
      <span class="text-[14px] text-[#667085]"
        >{{ pagination.total_count || 0 }} QRIS {{ pagination.total_count > 1 ? 'codes' : 'code'}} in your collection</span
    >
    </div>
    <div class="flex items-center justify-start md:justify-end w-full md:w-auto">
      <nz-input-group [nzPrefix]="prefixTemplateSearch" class="w-full md:min-w-[300px]">
        <input
          type="text"
          nz-input
          nzSize="large"
          placeholder="Search by name"
          [(ngModel)]="filterList.search"
          (ngModelChange)="onChangeSearch($event)"
          class="rounded-lg h-9"
        />
      </nz-input-group>
      <ng-template #prefixTemplateSearch>
        <i class="icon-search-normal-1 text-gray-400"></i>
      </ng-template>
    </div>
  </div>

  <div class="flex flex-col gap-2 w-full mt-4 overflow-hidden">
    <nz-table
      #table
      [nzData]="data"
      [nzTotal]="pagination.total_count"
      [nzPageSize]="filterList.limit"
      [nzShowPagination]="false"
      [nzShowSizeChanger]="false"
      [nzScroll]="{ x: '1000px' }"
    >
      <thead>
        <tr>
          <th nzWidth="250px">Name</th>
          <th nzWidth="200px">Merchant</th>
          <th nzWidth="150px">Provider</th>
          <th nzWidth="200px">Created</th>
          <th nzWidth="100px" nzRight>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of table.data">
          <td>{{ item.name }}</td>
          <td>{{ item.merchant_name }}</td>
          <td>
            <span class="text-blue-500 bg-blue-100 p-2 rounded-pill text-center w-[100px] flex items-center justify-center font-medium">
              {{ item.provider }}
            </span>
          </td>
          <td>{{ item.created_at | date: 'dd MMMM yyyy HH:mm' }}</td>
          <td nzRight>
            <button nz-button nzType="link" (click)="onDeleteQris(item.qris_id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <app-pagination
      [currentPage]="pagination.current_page"
      [totalItems]="pagination.total_count"
      [perPage]="filterList.limit"
      [disablePrev]="isDisPrev"
      [disableNext]="isDisNext"
      [perPageOptions]="[20, 40, 60, 80, 100]"
      (pageChange)="onPageChange($event)"
      (perPageChange)="onPerPageChange($event)"
      (itemsPerPageChange)="getListPage($event)">
    </app-pagination>
  </div>
</ng-container>

<app-delete-qris-modal
  [isVisible]="showDeleteModal"
  (cancel)="showDeleteModal = false"
  (confirm)="onDelete()"
></app-delete-qris-modal>
